export default "__VITE_ASSET__BPBXX2AO__"